import { getFormData } from "../../../common";

const FrontYardLivingAreaForm = (props) => {
  const { frontYards, livingAreas, selectedFrontYardId, selectedLivingAreaId } = props;
  return (<>
    <form style={{ minHeight: 30 }}>
      <div className={"row"}>
        {(frontYards.length > 0) && (
          <div className={"col-6 col-sm-4 col-md-3 col-lg-2 text-left"}>
            <select name={"frontYardId"} className={"form-control form-control-sm"} onChange={props.onChangeFrontYard} defaultValue={selectedFrontYardId}>
              <option value={''}>앞마당</option>
              {frontYards.map(v => (<option key={v.id} value={v.id}>{v.name}</option>))}
            </select>
          </div>
        )}
        {(livingAreas.length > 0) && (
          <div className={"col-6 col-sm-4 col-md-3 col-lg-2 text-left"}>
            <select name={"livingAreaId"} className={"form-control form-control-sm"} onChange={props.onChangeLivingArea} defaultValue={selectedLivingAreaId}>
              <option value={''}>생활권</option>
              {livingAreas.map(v => (<option key={v.id} value={v.id}>{v.name}</option>))}
            </select>
          </div>
        )}
      </div>
    </form>
  </>);
};

const FrontYardLivingAreaFormV2 = (props) => {
  const { frontYards, livingAreas, selectedFrontYardId, selectedLivingAreaId } = props;

  const onChangeFrontYard = (e) => {
    const formData = getFormData(e.target.form);
    delete formData.livingAreaId;
    props.onChangeFrontYard(formData);
  };

  const onChangeLivingArea = (e) => {
    const formData = getFormData(e.target.form);
    props.onChangeLivingArea(formData);
  };

  return (<>
    <form style={{ minHeight: 30 }}>
      <div className={"row form-group"}>
        {(frontYards.length > 0) && (
          <div className={"col-6 col-sm-4 col-md-3 col-lg-2 text-left"}>
            <select name={"frontYardId"} className={"form-control form-control-sm"} onChange={onChangeFrontYard} defaultValue={selectedFrontYardId}>
              <option value={''}>FrontYard</option>
              {frontYards.map(v => (<option key={v.id} value={v.id}>{v.name}</option>))}
            </select>
          </div>
        )}
        {(livingAreas.length > 0) && (
          <div className={"col-6 col-sm-4 col-md-3 col-lg-2 text-left"}>
            <select name={"livingAreaId"} className={"form-control form-control-sm"} onChange={onChangeLivingArea} defaultValue={selectedLivingAreaId}>
              <option value={''}>LivingArea</option>
              {livingAreas.map(v => (<option key={v.id} value={v.id}>{v.name}</option>))}
            </select>
          </div>
        )}
      </div>
    </form>
  </>);
};

const FrontYardLivingAreaFormOnly = (props) => {
  const { frontYards, livingAreas, selectedFrontYardId, selectedLivingAreaId } = props;
  return (
    <>
      {(frontYards.length > 0) && (
        <div className={"col-6 col-sm-4 col-md-3 col-lg-2 text-left"}>
          <select name={"frontYardId"} className={"form-control form-control-sm"} onChange={props.onChangeFrontYard} defaultValue={selectedFrontYardId}>
            <option value={''}>앞마당</option>
            {frontYards.map(v => (<option key={v.id} value={v.id}>{v.name}</option>))}
          </select>
        </div>
      )}
      {(livingAreas.length > 0) && (
        <div className={"col-6 col-sm-4 col-md-3 col-lg-2 text-left"}>
          <select name={"livingAreaId"} className={"form-control form-control-sm"} onChange={props.onChangeLivingArea} defaultValue={selectedLivingAreaId}>
            <option value={''}>생활권</option>
            {livingAreas.map(v => (<option key={v.id} value={v.id}>{v.name}</option>))}
          </select>
        </div>
      )}
    </>
  )
}

export {
  FrontYardLivingAreaForm,
  FrontYardLivingAreaFormOnly,
  FrontYardLivingAreaFormV2
};
